import { type HttpHandler } from "msw";

// eslint-disable-next-line no-restricted-imports
import * as allImportedMsw from "@vega-api/generated/index.msw";

export const genHandlers = Object.values(allImportedMsw).flatMap(
  (exportedValue): HttpHandler[] => {
    /**
     * We check if the exported value is a function. If it is, we call it
     * and check if the result is an array. This pattern specifically targets
     * the aggregator functions like `getIdpMock()`.
     */
    if (typeof exportedValue === "function") {
      const result = exportedValue();

      if (
        Array.isArray(result) &&
        result.every((item): item is HttpHandler => "predicate" in item)
      ) {
        return result;
      }
    }

    // If the export is not a handler array function, we return an empty array,
    // which flatMap will discard.
    return [];
  },
);
